import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-navy" data-id="element-41" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-42" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-43" data-mp="1v05w65xky8j2">
          Spend the hour coaching{' '}
          <span className="text-gold" data-id="element-44" data-mp="1l0ornru2e0oo">— not planning it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-45" data-mp="1l1zy5zew9mjh">
          Flag, 7v7 and youth tackle. Every practice built the same way, every
          week. Written, sequenced, ready to print and run.
        </p>

        <div className="mt-7" data-id="element-46" data-mp="179a8nl05pzhm">
          <Countdown size="sm" tone="dark" data-id="element-47" data-mp="17a1rrwcki4r0" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-48" data-mp="129e51mvdga2l">
          <div data-id="element-49" data-mp="xbcjmvah3yny">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-50" data-mp="xcx4ft6zk38m">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-white" data-id="element-51" data-mp="40zjzluu0rlp">
              Sideline Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-52" data-mp="3lfebnasb2fti">
            <span className="font-display text-4xl leading-none text-white" data-id="element-53" data-mp="3qhddgg8ed4oc">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-54" data-mp="hyo24lxilkn2">
          <CtaButton data-id="element-55" data-mp="myk5ciye181k">Yes — I want the season planned</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-56" data-mp="82ufg9q30ark">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-57" data-mp="2ss22c2b5o4i5">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-58" data-mp="2suwl7peith9g" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}